import { type AnyAction } from 'redux';
import { HEADER_SEARCH_CLOSED, HEADER_SEARCH_OPENED } from '../../actions/header-search';

type State = { inputWidth: number };

const initialState: State = { inputWidth: 0 };

export default (state: State = initialState, action: AnyAction): State => {
  switch (action.type) {
    case HEADER_SEARCH_OPENED:
      return { inputWidth: 200 };
    case HEADER_SEARCH_CLOSED: {
      return { inputWidth: 0 };
    }
    default:
      return state;
  }
};
